import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { TransactionRequestEtisalatInputParamsModel, TransactionRequestPayWCreditCardInputParamsModel } from 'src/app/card-operations-core/models/transaction-request-models';
import { product, productsServiceResModel } from 'src/app/card-operations/models/getProductsResponse.model';
import { IFirstStepComplete, ISelectedChargeInfo } from 'src/app/card-operations/models/paymenType.model';
import { ProductService } from 'src/app/card-operations/services/getProducts.service';
import { AppConfig } from 'src/app/config-service/app.config';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';
import { BalanceService } from 'src/app/home/services/cardBalance.service';
import { IOnlineChargeMediator, OnlineChargeBaseComponent, OnlineChargeMediator } from '../utility-classes/online-charge-classes';
import { ValidateAmount } from './utility-classes/payment-amount-validators';

@Component({
  selector: 'app-first-step',
  templateUrl: './firs-step.component.html',
  styleUrls: ['./firs-step.component.scss', '../../../card-operations.component.css']
})
export class FirstStepComponent extends OnlineChargeBaseComponent implements OnInit {
  @Input() modalType!: string;
  @Input() modalInput!: string;
  @Input() concreteMediator!: IOnlineChargeMediator;

  apiSettings = AppConfig.settings;
  
  forms = new FormGroup({
    amountForm : new FormControl('', [Validators.required])
  });

  aliasNoControlWarningLabel = '';
  queryAlias = '';
  selectedCardProductCode = '0';
  selectedChargeAmountType = 0;
  selectedChargeAmount = 0;
  selectedChargeCommissionAmount = 0;
  selectedChargeTotalAmount = 0;
  productResult!: productsServiceResModel | null;
  productsArray: Array<product> = [];
  private cardAlias:string = '';
  isLoading = false;
  isProductsReceived:boolean = false;
  private product!:product;
  balanceResult = '0';

  public creditCardparams!: TransactionRequestPayWCreditCardInputParamsModel;
  public etisalatRequiredParams!: TransactionRequestEtisalatInputParamsModel;

  constructor(
    private toastr: ToastrService,
    public translate: TranslateService,
    public activeModal: NgbActiveModal,
    public restGetProducts: ProductService,
    public restGetBalance: BalanceService,
    protected mediator: OnlineChargeMediator
  ) { 
    super(mediator);
  }

  ngOnInit(): void {
    this.setMediator(this.concreteMediator);

    if(!!this.modalInput){
      this.queryAlias = this.modalInput;
      this.onChangeQueryAliasNo(this.queryAlias);
    }

    this.forms.controls['amountForm'].valueChanges.subscribe(value => {
      this.selectedChargeAmount = value;
    });
  }

  onlineCharge_onNextClick = () => {
    if(this.amountErrors.valid){
      const product:product = this.findProduct(
        this.selectedCardProductCode, 
        this.productResult!.InventoryArray
      )!;

      const message = this.calculateAllAmountsAndEmit(product, 1, this.selectedChargeAmount);

      if (!this.aliasControl(this.queryAlias)) {
        this.aliasNoControlWarningLabel = 'Please enter your card number correctly';
      } else {
        this.mediator.notifyOnlineCharge(this, 'AMOUNT_SELECTED', message);
      }
    }
  };

  onChangeQueryAliasNo = (text:any) => {
    this.isProductsReceived = false;

    this.queryAlias = this.aliasFormatter(this.queryAlias, text);
    this.cardAlias = this.queryAlias.split('-').join('').slice(0, -1);

    this.selectedCardProductCode = '0';

    if (this.modalType === 'AddtoFav') {
      return;
    }

    if (this.aliasControl(this.queryAlias)) {
      this.aliasNoControlWarningLabel = '';
      this.isLoading = true;
      new Promise((resolve, reject) => {
        let alias = this.aliasReformatter(this.queryAlias);

        this.restGetBalance.getCardBalanceResult(alias).subscribe(
          (resp:any) => {
            if (resp.result.code !== 0) {
              this.aliasNoControlWarningLabel = 'Giriş Yapınız!';
              this.activeModal.dismiss('Cross click');
            } else if (resp.result.code == 0) {
              resp.cardlist.forEach((el:cardDetailResModel) => {
                localStorage.setItem('card-type', el.cardType)
                this.isLoading = false;
                this.balanceResult = el.balance;
                this.selectedCardProductCode = el.product_code;
                this.getProductsAndValidate(el.product_code);
              });
            } else {
              this.isLoading = false;
              this.aliasNoControlWarningLabel = resp.result.message;
            }
          },
          (error:unknown) => {
            this.isLoading = false;
            reject(error);
          }
        );
      });
    } else {
      if (this.queryAlias.length > 5) {
        this.aliasNoControlWarningLabel = 'Kart numaranızı eksiksiz giriniz';
      }
    }
  };

  private calculateAllAmountsAndEmit = (
    product:product, 
    selectedChargeAmountType: number, 
    selectedChargeAmount:number
  ) : IFirstStepComplete => {
    let transactionCommission = this.selectedChargeAmount * product.commission['24'].commissionRate +
      product.commission['24'].commissionPerTransaction;
    
    if (transactionCommission > product.commission['24'].maxCommissionAmount) {
      transactionCommission = product.commission['24'].maxCommissionAmount;
    }

    const selectedChargeCommissionAmount = transactionCommission;
    const selectedChargeTotalAmount = selectedChargeAmount + selectedChargeCommissionAmount;

    const amountParameters = {
      selectedChargeAmount: selectedChargeAmount,
      selectedChargeTotalAmount: selectedChargeTotalAmount, 
      selectedChargeAmountType: selectedChargeAmountType,
      selectedChargeCommissionAmount: selectedChargeCommissionAmount,
      queryAlias: this.queryAlias,
      product_code: product.product_code,
      cardAlias: this.cardAlias,
      product_type: product.process_type,
      media_type: product.media_type,
      price: JSON.stringify(product.price)
    };

    return amountParameters;
  }

  findProduct(selectedCardProductCode:string, inventoryArray:product[]): product | undefined {
    for (let i = 0; i < inventoryArray.length; i += 1) {
      if (selectedCardProductCode === inventoryArray[i].product_code){
        return inventoryArray[i];
      }
    }

    return undefined;
  }
  
  aliasControl(aliasNo:any) {
    let state = false;
    const intArray:Array<any> = [];
    let toplam = 0;
    let lastDigit = 0;
    let modDigit = 0;

    // Sayının Rakamlarını intArray Dizisine Pushlama İşlemi
    const b = aliasNo.split('').map(function (item:any) {
      intArray.push(parseInt(item, 10));
    });

    for (let i = 0; i < 5; i += 1) {
      toplam += intArray[i];
    }

    for (let i = 6; i < 11; i += 1) {
      toplam += intArray[i];
    }

    lastDigit = intArray[12];
    modDigit = toplam % 10;

    /*
      STATE TRUE dönüyorsa girilen alias numarası DOĞRU
      STATE FALSE dönüyorsa girilen alias numarası YANLIŞ
    */
    if (lastDigit === modDigit) {
      state = true;
    }

    return state;
  }

  aliasFormatter(oldAliasNo:any, newAliasNo:any) {
    const isDeleted =
      oldAliasNo === newAliasNo + '-' && oldAliasNo.length > newAliasNo.length;
    if (isDeleted) {
      return newAliasNo;
    }
    if (newAliasNo.length === 20) return oldAliasNo;
    else if (newAliasNo.length > 13) {
      var v = newAliasNo.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
      var matches = v.match(/\d{4,16}/g);
      var match = matches && (matches[0] || '');
      var parts = [];

      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }

      if (parts.length) {
        return parts.join(' ');
      } else {
        return newAliasNo;
      }
    }
    newAliasNo = newAliasNo.replace(/ /g, '');
    const splitText = newAliasNo.split('-');
    if (splitText.length === 1) {
      // eger "-" ifadesi bulunmuyor ise
      if (newAliasNo.length === 5) {
        // 5. karaktere geldi ise
        return newAliasNo + '-';
      } else if (newAliasNo.length === 6) {
        // 6. karaktere geldi "-" işareti yok ise
        return newAliasNo.slice(0, -1) + '-' + newAliasNo.slice(-1);
      } else {
        // normal durumda ise
        let cache = newAliasNo;
        if (newAliasNo.length > 5) {
          // eğer hızlı yazıldı ve 5. elemandan sonra "-" ifadesi eklenmedi ise
          cache = cache.slice(0, 5) + '-' + cache.slice(5, cache.length);
        }
        if (newAliasNo.length > 12) {
          cache = cache.slice(0, 11) + '-' + cache.slice(11, cache.length);
        }
        if (
          newAliasNo.length < oldAliasNo.length &&
          newAliasNo.replace(/\D/g, '').length === 11
        ) {
          return `${cache.slice(0, cache.length - 1)}-${
            cache[cache.length - 1]
          }`;
        }
        return cache;
      }
    } else if (splitText.length === 2) {
      // eger  bir tane "-" ifadesi bulunuyor ise
      if (splitText[0].length < 6) {
        // eger ilk tireden önceki ifade 6 karakterden küçük ise
        if (newAliasNo.length === 11) {
          // 11. karaktere geldi ise
          return newAliasNo + '-';
        } else if (newAliasNo.length === 12) {
          // 12. karaktere geldi ve hala 1 tane "-" işareti var ise
          return newAliasNo.slice(0, -1) + '-' + newAliasNo.slice(-1);
        } else {
          // normal durumda ise
          let cache = newAliasNo;
          if (newAliasNo.length > 12) {
            cache = cache.slice(0, 11) + '-' + cache.slice(11, cache.length);
          }
          return cache;
        }
      } else {
        // eger ilk tireden önceki ifade 6 karakterden küçük değil ise
        return oldAliasNo;
      }
    } else if (splitText.length === 3) {
      // eger  iki tane "-" ifadesi bulunuyor ise
      if (splitText[0].length < 6 && splitText[1].length < 6) {
        // eger ilk tireden önceki ifade 6 karakterden küçük ise ve 2. tire ile arasında 5 karakter var ise
        if (splitText[2].length < 2) {
          return newAliasNo;
        } else {
          return oldAliasNo;
        }
      } else {
        // Eger tireler arasında fazla karakter yazılmış ise
        return oldAliasNo;
      }
    } else {
      return oldAliasNo;
    }
  }

  aliasReformatter(aliasNo:any) {
    /*
      formatter(aliasNo) EXAMPLE:
      Entry = 33800-00002-6
      Output = 3380000002
    */
    const newAlias = aliasNo.split('-').join('');
    return newAlias.substring(0, 10);
  }

  private getProductsAndValidate(selectedCardProductCode:string) {
    this.isLoading = true;
    this.restGetProducts.getProductResult()
    .pipe(
      tap((response:any) => {
        localStorage.setItem('productArr', JSON.stringify(response));
        this.productResult = JSON.parse(JSON.stringify(response) || '[]');
        
        this.product = this.findProduct(selectedCardProductCode, this.productResult!.InventoryArray)!
      }),
      tap((response:any) => {
        const max_amount = this.product.price.max_charge_amount;
        const min_amount = this.product.price.min_charge_amount;
        this.forms.controls['amountForm'].addValidators([ValidateAmount(min_amount, max_amount)]);
      })
    )
    .subscribe(
      (resp:any) => {
        this.isLoading = false;
        this.isProductsReceived = true;
      },
      (error:unknown) => {
        this.isLoading = false;
      }
    );
  }

  get amountErrors(){
    return this.forms.controls["amountForm"];
  }

  get invalidAmountError(){
    if(!!this.forms.controls["amountForm"].errors!.amountInvalid){
      return this.forms.controls["amountForm"].errors!.amountInvalid.error
    };
  }

}